<template>
    <!--出行任务-->
    <div class="view" :style="{ paddingTop: barh(105) }">
        <div class="content">
            <my-top
                title="出行任务"
                lefttext="返回"
                @leftclick="togo('/application')"
            ></my-top>
            <div class="screenbox" :style="{ top: navbarheight }">
                <div class="sarch">
                    <search
                        v-model="params.query.address"
                        placeholder="输入搜索内容"
                        @blur="searchLoad"
                        input-align="center"
                    />
                </div>
            </div>
            <pull-refresh v-model="refreshing" @refresh="onRefresh">
                <list
                    class="cont-box"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="getlistdata"
                >
                    <div class="item-box" v-for="(item, n) in list" :key="n">
                        <cell style="background-color: #f5f5f5">
                            <template #title>
                                {{ new Date(item.time).getMonth() + 1 }}月{{
                                    new Date(item.time).getDate()
                                }}日 {{ item.week }}
                            </template>
                            <template #default>
                                <span style="color: #000"
                                    >{{
                                        new Date(item.time).getFullYear()
                                    }}年</span
                                >
                            </template>
                        </cell>
                        <cell
                            v-for="items in item.records"
                            class="simpleList"
                            :key="items.id"
                            @click.stop="handleClick(items)"
                        >
                            <template #title>
                                <div style="overflow: hidden">
                                    <div class="listItem">
                                        <div
                                            style="
                                                max-width: calc(100% - 60px);
                                                float: left;
                                                font-weight: bold;
                                                font-size: 15px;
                                            "
                                        >
                                            <div class="van-ellipsis">
                                                目的地：{{ items.address }}
                                            </div>
                                        </div>
                                        <div class="listVal van-ellipsis">
                                            <!--出行状态0未开始 1使用中 2已归队-->
                                            <span
                                                v-if="items.travelStatus == 2"
                                                style="color: #999999"
                                                >已结束</span
                                            >
                                            <span
                                                v-else-if="
                                                    items.travelStatus == 0
                                                "
                                                style="color: #02bd6e"
                                                >未开始</span
                                            >
                                            <span
                                                v-else-if="
                                                    items.travelStatus == 1
                                                "
                                                style="color: #ffa500"
                                                >进行中</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template #label>
                                <div class="van-ellipsis">
                                    <div class="van-ellipsis">
                                        往返时间：{{ items.goTime }} 至
                                        {{ items.comeTime }}
                                    </div>
                                    <div class="van-ellipsis">
                                        申请人：{{ items.personName }}
                                    </div>
                                    <div class="van-ellipsis">
                                        车辆：{{ GetCarInfo(items) }}
                                    </div>

                                    <div class="listItem">
                                        <div class="listVal van-ellipsis">
                                            <span
                                                v-if="items.travelStatus == 1"
                                            >
                                                <over-dialog
                                                    :id="items.id"
                                                    @refresh="onRefresh"
                                                ></over-dialog>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </cell>
                    </div>
                </list>
            </pull-refresh>
        </div>
    </div>
</template>

<script>
import { Button, Cell, Dialog, Icon, List, PullRefresh, Search } from "vant";
import application from "@api/application";
import overDialog from "./overDialog";
import { BaiduMap } from "vue-baidu-map";
import OverDialog from "./overDialog.vue";
// import loading from "../../../utils/loading";
export default {
    name: "useCar",
    components: {
        Cell,
        Search,
        List,
        PullRefresh,
        Button,
        Icon,
        overDialog,
        BaiduMap,
        Dialog,
        OverDialog,
    },
    data() {
        return {
            token: this.$store.state.user.token,
            projectId: this.$store.state.project.projectId,
            searchvalue: "",
            list: [],
            show: false,
            loading: false,
            finished: false,
            refreshing: false,
            rotate: true,
            sortName: "正序",
            center: { lng: 0, lat: 0 },
            zoom: 15,
            address: "",
            params: {
                needCount: true,
                pageNo: 1,
                pageSize: 10,
                query: {
                    address: "",
                    isApp: true,
                    isTask: true,
                },
            },
        };
    },
    computed: {},
    methods: {
        /**
         * 司机信息展示
         **/
        GetCarInfo(items) {
            let info = [];
            items.carApplication.carDispatchRecords.map((i, n) => {
                info.push(i.carInfo.carNumber + " " + i.carInfo.color);
            });
            return info.join("；");
        },
        GetCarPerson(items) {
            let info = [];
            items.carApplication.carDispatchRecords.map((i, n) => {
                info.push(i.carInfo.driverName);
            });
            return info.join("；");
        },
        handleClick(items) {
            this.$router.push({
                path: "/application/travelTask/travelTaskDetail",
                query: {
                    baseInfo: items,
                },
            });
            //跳转录音调试
            // this.$router.push({
            //     path: "/application/travelTask/record",
            // });
        },

        getlistdata(type = "add") {
            console.log(type);
            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
            }
            if (type == "new") {
                this.list = [];
                this.params.pageNo = 1;

                this.loading = true;
                this.finished = false;
            }

            application
                .getQueryAppRecord(this.params)
                .then((res) => {
                    if (res.code == "0") {
                        this.list = this.list.concat(res.data.list);

                        this.loading = false;

                        this.params.pageNo++;
                        if (res.data.pageNum >= res.data.pages) {
                            this.finished = true;
                        }
                    } else {
                        this.loading = false;
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.finished = true;
                });
        },
        searchLoad() {
            this.getlistdata("new");
        },

        onRefresh() {
            this.getlistdata("new");
            this.finished = false;
            this.loading = true;
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
.down {
    transition: all 1ms;
}
.up {
    transform: rotate(-180deg);
    transition: all 1ms;
}

.view {
    background-color: #ffffff;
}
.content {
    padding-bottom: 50px;
    .screenbox {
        width: 100%;
        position: fixed;
        left: 0;
        z-index: 2;
        .sarch {
            ::v-deep .van-search {
                .van-search__content {
                    border-radius: 20px;
                }
            }
        }
        .sarchtabs {
            ::v-deep .van-tabs__line {
                background-color: #018fe0;
                bottom: 18px;
            }
        }
    }
    .cont-box {
        .item-box {
            background-color: #ffffff;
            overflow: hidden;
            .van-cell__title {
                overflow: hidden;
            }
            .titBtn {
                display: inline-block;
                font-size: 12px;
                padding: 2px 8px;
                margin-left: 10px;
                border-radius: 4px;
            }
            .titBtn.err {
                color: #f5222d;
                border: 1px solid #ffa39e;
                background-color: #fef0ef;
            }
            .titBtn.default {
                color: #000000;
                border: 1px solid #d9d9d9;
                background-color: #f5f5f5;
            }
        }
        .simpleList {
            border-bottom: 1px solid #dddddd;
            display: flex;
            /*justify-content: center;*/
            align-items: center;
            ::v-deep .van-ellipsis {
                line-height: 20px;
            }
            .listItem {
                font-size: 14px;
                display: flex;
                display: -webkit-box;
                display: -webkit-flex;
                box-sizing: border-box;
                width: 100%;
                line-height: 24px;
                white-space: normal;
                text-align: left;
                overflow: hidden;
                .listTitle,
                .listVal {
                    flex: 1;
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                }
                .listVal {
                    text-align: right;
                }
            }
            .listCtn {
                color: #999999;
                font-size: 12px;
                .listVal {
                    font-size: 12px;
                }
            }
            .listBtn {
                .listTitle {
                    color: #018fe0;
                }
            }
        }
    }
    .btn {
        > span:first-child {
            background-color: #70b603;
        }
        > span:last-child {
            background-color: #169bd5;
        }
    }
}
</style>
